/**
 * Enum that defines event status options.
 */
export enum EventTransparency {
  Opaque = 1,
  Transparent = 2
}
